let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Afgd")).then(() => parcelRequire('Plo13'));